// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"LayoutVariant1_contentWrapper__o7PTc","thumbColumn":"LayoutVariant1_thumbColumn__bsvwI"};